/**
 * CourseFileService
 * Service for managing course resource files
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for course file CRUD operations
 */
export class CourseFileService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? CourseFileService.DEFAULT_SERVICE_PATH,
            basePath: CourseFileService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all files for a course
     * @param courseId - The course ID
     * @returns Array of course files
     */
    async byCourse(courseId) {
        const response = await this.byCourseRaw(courseId);
        return response.data ?? [];
    }
    /**
     * Get all files for a course with full response
     * @param courseId - The course ID
     * @returns ResponseData with array of course files
     */
    byCourseRaw(courseId) {
        const url = this.buildUrl(`by-course/${courseId}`);
        return this.http.get(url);
    }
}
CourseFileService.DEFAULT_SERVICE_PATH = 'ac-courses';
CourseFileService.BASE_PATH = 'api/course-files';
//# sourceMappingURL=CourseFileService.js.map